<template>
  <div class="card mx-auto mt-5" style="width: 18rem">
    <div class="card-body zeropadding p-2">
      <span class="mx-auto fw-bold"> Auctioneer</span>
      <!-- {{ store.user_type }} -->
      <input
        type="text"
        class="form-control mt-2"
        placeholder="Email"
        v-model="email"
      />
      <input
        type="password"
        class="form-control mt-2"
        placeholder="Password"
        v-model="password"
      />
      <button class="btn btn-primary mt-2 mb-2" @click="signInWithEmail()">
        Login
      </button>
    </div>
  </div>
</template>
<script setup>
import supabase from "../../supabase/config";
import { ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "../../store/index";
const store = useStore();
const router = useRouter();
//const email = ref("auc_auctioneer@gmail.com");
//const password = ref("auc_auctioneer");
const email = ref("");
const password = ref("");

async function signInWithEmail() {
  const { data, error } = await supabase.auth.signInWithPassword({
    email: email.value,
    password: password.value,
  });
  if (!error) {
    // console.log(data);
    store.setUser({ user: data.user, user_type: "auctioneer" });
    router.push("/home");
  }
}
</script>
<style scoped>
.zeropadding {
  padding: 0px;
}
</style>
